/**************************************************
 * Nombre:       Tarjeta_Fechas_RG
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Fechas from "./Tarjeta_Fechas";
import {Apartment, ConfirmationNumber, House} from '@mui/icons-material'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Fechas_RG = ({fecha, item, cupos}) => {
    const {sCell} = useResponsive()
    let ocupados = cupos
    let cuposDisponibles = parseInt(item.cupos)

    const IconoDatos = ({Icono, titulo, texto}) => {
        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid container size={{xs: 1, sm: 1, md: 1}}>
                    <Icono sx={{width: 30, height: 30}}/>
                </Grid>

                <Grid container size={{xs: 11, sm: 11, md: 11}} sx={{mt: 0.5, pl: 1}}>
                    <Typography sx={{fontWeight: 800, fontSize: 18, lineHeight: 1.1}}>{titulo} <span
                        style={{fontWeight: 300}}> {texto}</span></Typography>
                </Grid>


            </Grid>
        )
    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={6}
        >


            <Grid container size={{xs: 12, sm: 6, md: 6}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Tarjeta_Fechas item={fecha} idLanding={item.id} cupos={cupos} />
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: -5}} justifyContent={'flex-end'}>
                        <Typography sx={{
                            fontSize: 14,
                            fontWeight: 600
                        }}>{`${cuposDisponibles - ocupados} de ${cuposDisponibles} Disponibles`}</Typography>
                    </Grid>


                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{mt: sCell ? -4 : 2}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={0}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <IconoDatos Icono={House} titulo={'Direccion: '} texto={fecha.direccion}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                        <IconoDatos Icono={Apartment} titulo={'Ciudad: '} texto={fecha.ciudad}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                        <IconoDatos Icono={ConfirmationNumber} titulo={'Entrada: '}
                                    texto={fecha.entrada}/>
                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Fechas_RG